import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-input-text',
  templateUrl: './input-text.component.html',
  styleUrls: ['./input-text.component.scss']
})
export class InputTextComponent implements OnInit {

  title: string = 'Atención';
  value: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogReference: MatDialogRef<InputTextComponent>,
  ) {

  }

  ngOnInit() {
  }

  close() {
    this.dialogReference.close(null)
  }

  save() {
    this.dialogReference.close(this.value);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/input-text/input-text.component.ts